<template>
  <v-card
    :class="breakPointChange"
    class="ml-auto pa-5 mt-3 body-2 green lighten-5"
    elevation="0"
  >
    <div class="d-flex">
      <div class="mr-3 text-center">
        <PixIcon
          v-if="isAPixPayment"
          opacity="0.3"
          height="20"
          width="20"
        />

        <v-icon color="grey">
          {{ methods[paymentMethod] }}
        </v-icon>
      </div>
      <div>
        <h4 class="subtitle-2">
          {{ $t('quote.hint.paymentAmountAndMethod', { amount, method }) }}
        </h4>

        <p v-if="isDiscountMoreThanZero && isAPixPayment" class="mb-0 caption">
          {{ $t('quote.hint.onSightDiscount', { discount }) }}
        </p>

        <p v-if="isACreditCardPayment" class="mb-0 caption">
          {{ $t('quote.hint.installments', { installments }) }}
        </p>
      </div>
    </div>
  </v-card>
</template>

<script>
import PixIcon from '@/components/icons/Pix'

import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'QuotePaymentMethods',

  components: {
    PixIcon,
  },

  props: {
    paymentMethod: {
      type: String,
    },

    quoteItems: {
      type: Object,
    },

    payWithFci: {
      type: Boolean,
    },

    isEviction: {
      type: Boolean,
    },
  },

  computed: {
    breakPointChange() {
      return !this.$vuetify.breakpoint.mobile && 'mw-400'
    },

    method() {
      return this.$t(`payment.type.${this.paymentMethod}`)
    },

    isAPixPayment() {
      return this.paymentMethod === 'ASAAS_PIX'
    },

    isACreditCardPayment() {
      return this.paymentMethod === 'ASAAS_CREDIT_CARD'
    },

    amount() {
      if (this.payWithFci)
        return this.formatMoney(
          this.quoteItems.net_fci
            ? this.quoteItems.net_fci
            : this.quoteItems.subtotal
        )

      if (!this.payWithFci && !this.isEviction)
        return this.formatMoney(
          this.isAPixPayment
            ? this.quoteItems.total
            : this.quoteItems.total_by_installments
        )

      if (this.isEviction)
        return this.formatMoney(this.quoteItems?.total)
    },

    discount() {
      return this.formatMoney(this.quoteItems?.cash_discount)
    },

    isDiscountMoreThanZero() {
      return this.quoteItems?.cash_discount > 0
    },

    installments() {
      return this.quoteItems?.charge?.installments?.length
    }
  },

  data() {
    return {
      formatMoney: catalogMonetary,

      methods: {
        VALUELESS: 'mdi-bank',
        ASAAS_BOLETO: 'mdi-barcode',
        BALANCE: 'mdi-wallet-outline',
        ASAAS_CREDIT_CARD: 'mdi-credit-card-outline',
      },
    }
  }
}
</script>
